import styled from 'styled-components';

export default function AvatarIcon({ name, photoURL, size = 36 }) {
  if (photoURL) {
    return <AvatarImg src={photoURL} alt={name || ''} $size={size} />;
  }

  const initials = (name || '?')
    .split(' ')
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const hue = (name || '').split('').reduce((acc, c) => acc + c.charCodeAt(0), 0) % 360;

  return (
    <AvatarCircle $size={size} $hue={hue}>
      {initials}
    </AvatarCircle>
  );
}

const AvatarImg = styled.img`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

const AvatarCircle = styled.div`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background: hsl(${({ $hue }) => $hue}, 60%, 65%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ $size }) => Math.round($size * 0.4)}px;
  font-weight: 600;
  flex-shrink: 0;
`;
